<template>
  <div class="dropdown" style="float:left;">
    <button class="dropbtn attendance-dropdown at-type-dropdown">
      <p>
        <span v-if="type">{{ types[type] }}</span>
        <span v-else>Type</span>
      </p>
      <i class="fas fa-caret-down"></i>
    </button>
    <div class="dropdown-content">
      <a href="#" @click.prevent="filter(null)">All</a>
      <a href="#" v-for="(type, index) in types" :key="index" @click.prevent="filter(index)">{{ type }}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TypeFilter',
    props: {
      type: {
        default: null
      }
    },
    data() {
      return {
        types: {1: 'Unidentified', 2: 'Identified'}
      }
    },
    methods: {
      filter(value) {
        this.$emit('type', value);
      }
    }
  }
</script>
